import { VideoStyleStrategy } from './video-style-strategy';
import {
  GetStandardBannersSpecificRule,
  StandardBannersSpecificRule
} from '../standard-banners/get-standard-banners-specific-rule';

export class StandardBannersVideoStyleStrategy extends VideoStyleStrategy {
  protected getVideoStyle(): Record<string, string | number> {
    let videoStyle = super.getVideoStyle();
    const rule = GetStandardBannersSpecificRule(
      this.videoStore.videoClosestRatio.value
    );

    if (rule === StandardBannersSpecificRule.COVER) {
      videoStyle['object-fit'] = 'cover';
    }

    return videoStyle;
  }
}
